var InvitedList = [
  {
      id: 0,
      name: 'Mor Vered',
      image: 'mor',
      affiliation: 'Monash University',
      link: 'https://research.monash.edu/en/persons/mor-vered',
    },
    {
      id: 1,
      name: 'Antonio Rago',
      image: 'antonio',
      affiliation: 'Kings College London',
      link: 'https://antoniorago.github.io/',
    }
];

var PanelList = [
  {
      id: 0,
      name: 'Mor Vered',
      image: 'mor',
      affiliation: 'Monash University',
      link: 'https://research.monash.edu/en/persons/mor-vered',
    },
    {
      id: 1,
      name: 'Antonio Rago',
      image: 'antonio',
      affiliation: 'Kings College London',
      link: 'https://antoniorago.github.io/',
    },
    {
    id: 2,
    name: 'Sarath Sreedharan',
    image: 'sarath',
    affiliation: 'Colorado State University',
    link: 'http://sarathsreedharan.com/',
  }
];

var OrganizingTeamList = [
  {
    id: 1,
    name: 'Rebecca Eifler',
    image: 'rebecca',
    affiliation: 'LAAS-CNRS',
    link: 'https://www.linkedin.com/in/rebecca-eifler-b56652144/',
  },
  {
    id: 2,
    name: 'Benjamin Krarup',
    image: 'ben',
    affiliation: 'Kings College London',
    link: 'https://scholar.google.co.uk/citations?user=yEjXNsQAAAAJ&hl=en',
  },
  {
    id: 3,
    name: 'Alan Lindsay',
    image: 'alanL',
    affiliation: 'Heriot-Watt University',
    link: 'https://researchportal.hw.ac.uk/en/persons/alan-lindsay',
  },
  {
    id: 4,
    name: 'Lindsay Sanneman',
    image: 'lindsay',
    affiliation: 'Arizona State University',
    link: 'https://www.lindsaysanneman.com/',
  },
  {
    id: 6,
    name: 'Silvia Tulli',
    image: 'silvia',
    affiliation: 'Sorbonne University',
    link: 'https://silviatulli.com/',
  },
  {
    id: 7,
    name: 'Stylianos Vasileiou',
    image: 'stylianos',
    affiliation: 'New Mexico State University',
    link: 'https://thestlucas.com/',
  },
  {
    id: 8,
    name: 'Pulkit Verma',
    image: 'pulkit',
    affiliation: 'MIT',
    link: 'https://pulkitverma.net/',
  },
];

var SteeringCommitteeList = [
  {
    id: 8,
    name: 'Jeremy Frank',
    image: 'frank',
    affiliation: 'NASA',
    link: 'https://www.linkedin.com/in/jeremy-frank-62141bb3/',
  },
  {
    id: 9,
    name: 'Claudia Goldman',
    image: 'claudia',
    affiliation: 'General Motors',
    link: 'https://il.linkedin.com/in/claudiagoldman',
  },
  {
    id: 10,
    name: 'Jörg Hoffmann',
    image: 'joerg',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/hoffmann/',
  },
  {
    id: 11,
    name: 'Subbarao Kambhampati',
    image: 'rao',
    affiliation: 'Arizona State University',
    link: 'https://rakaposhi.eas.asu.edu/',
  },
  {
    id: 6,
    name: 'David Smith',
    image: 'david',
    affiliation: 'PS Research',
    link: 'http://psresearch.xyz/',
  },
  {
    id: 7,
    name: 'William Yeoh',
    image: 'william',
    affiliation: 'Washington University in St. Louis',
    link: 'https://sites.wustl.edu/wyeoh/',
  },
];

var PCList = [
  {
    id: 0,
    name: 'Pascal Bercher',
    affiliation: 'Australian National University, Australia',
  },
  {
    id: 1,
    name: 'Daniel Fišer',
    affiliation: 'Aalborg University, Denmark',
  },
  {
    id: 2,
    name: 'Ho Chit Siu',
    affiliation: 'MIT Lincoln Laboratory, USA',
  },
  {
    id: 3,
    name: 'Christabel Wayllace',
    affiliation: 'New Mexico State University, USA',
  },
  {
    id: 4,
    name: 'Akkamahadevi Hanni',
    affiliation: 'Arizona State University, USA',
  },
  {
    id: 5,
    name: 'Daniel Gnad',
    affiliation: 'Heidelberg University, Germany and Linköping University, Sweden',
  },
  {
    id: 6,
    name: 'Alban Grastien',
    affiliation: 'Australian National University, Australia',
  },
  {
    id: 7,
    name: 'Rohan R Paleja',
    affiliation: 'Purdue University, USA',
  },
  {
    id: 8,
    name: 'Shashank Shekhar',
    affiliation: 'University of Caen Normandy, France',
  },
  {
    id: 9,
    name: 'Mohammad Yousefi',
    affiliation: 'Australian National University, Australia',
  },
  {
    id: 10,
    name: 'Emile Siboulet',
    affiliation: 'LAAS-CNRS, France and Safran Electronics & Defense, France',
  },
];

var ProjectList = [
  {
    id: 8,
    name: 'TUPLES',
    image: 'tuples',
    link: 'https://tuples.ai/',
  },
];

export {
  OrganizingTeamList,
  SteeringCommitteeList,
  PCList,
  InvitedList,
  PanelList,
  ProjectList,
};
